import { istKeinOrt, ortsSchluessel } from '@genealogy-app/shared';
import { ladeKartenOrte } from '@/api/orte.api';

// ─── Orte auf der Karte ──────────────────────────────────────────────────────
//
// Hier stand einmal das Geocoding selbst: eine Anfrage je Ort an einen fremden
// Dienst, 1,1 Sekunden Pause dazwischen (dessen Regel), Ergebnisse im
// sessionStorage. Das hatte drei Fehler auf einmal:
//
//   1. Es hielt nicht. Beim nächsten Öffnen des Browsers ging alles von vorn
//      los. Ein Stammbaum mit 400 verschiedenen Orten brauchte über sieben
//      Minuten, bis die Karte vollständig war.
//   2. Es rechnete jeder für sich. Zehn Mitglieder eines Stammbaums stellten
//      dieselben 400 Anfragen zehnmal.
//   3. Es hielt die Regel nur einzeln ein. Der Dienst erlaubt eine Anfrage je
//      Sekunde; zwanzig Browser, die sich jeder daran halten, machen zusammen
//      zwanzig – und fliegen berechtigterweise hinaus.
//
// Jetzt löst der Server auf, einmal, dauerhaft. Hier bleibt das Nachschlagen
// in einer Liste, die in einer einzigen Anfrage ankommt.

export interface GeoResult {
  lat: number;
  lng: number;
  displayName: string;
  /** Steht auf true, wenn die Zuordnung zweifelhaft ist – die Karte markiert das. */
  zweifelhaft?: boolean;
}

/**
 * Holt die Koordinaten zu den übergebenen Ortstexten.
 *
 * Die Schlüssel der zurückgegebenen Map sind die Texte, die hereingegeben
 * wurden – der Aufrufer muss von der Normalisierung nichts wissen.
 */
export async function geocodePlaces(places: string[]): Promise<Map<string, GeoResult>> {
  const ergebnis = new Map<string, GeoResult>();
  const gesucht = places.filter((p) => !istKeinOrt(p));
  if (gesucht.length === 0) return ergebnis;

  const orte = await ladeKartenOrte();
  const nachSchluessel = new Map(orte.map((o) => [o.schluessel, o]));

  for (const text of gesucht) {
    const treffer = nachSchluessel.get(ortsSchluessel(text));
    if (!treffer) continue;
    ergebnis.set(text, {
      lat: treffer.lat,
      lng: treffer.lon,
      displayName: treffer.anzeigename ?? treffer.rohtext,
      zweifelhaft: treffer.verdacht !== 'ok',
    });
  }

  return ergebnis;
}
